import { AdditionalPageOptions } from '../interface';

/**
 * Get CMS config from additionalPageOptions
 */
export const getCMSConfig = () => window.additionalPageOptions as AdditionalPageOptions;

/** Get every level IDs from the CMS config */
export const getCMSLevelIds = () => Object.values(getCMSConfig().levelIds);
